import { BarChart, Bar, XAxis, YAxis, LabelList, CartesianGrid, Legend, Label } from "recharts";
import React from "react";
import { Tooltip } from "@mui/material";

const HorizontalStackedBarGraph = ({ data }) => {
  return (
    <BarChart width={850} height={230} data={data}>
      <XAxis dataKey="name" axisLine={false} />
      <YAxis domain={[0, 100]} allowDecimals={false}>
        <Label value="Ability" position="insideLeft" angle={-90} offset={0} />
      </YAxis>
      <Tooltip />
      <Legend />
      <Bar dataKey="Pre-Assessment" fill="#8884d8" barSize={50} />
      <Bar dataKey="Post-Assessment" fill="#82ca9d" barSize={50} />
    </BarChart>
  );
};

export default HorizontalStackedBarGraph;
